import { render, staticRenderFns } from "./LazyLoadWebComponent.vue?vue&type=template&id=2fa8de7f&scoped=true"
import script from "./LazyLoadWebComponent.vue?vue&type=script&lang=ts"
export * from "./LazyLoadWebComponent.vue?vue&type=script&lang=ts"
import style0 from "./LazyLoadWebComponent.vue?vue&type=style&index=0&id=2fa8de7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa8de7f",
  null
  
)

export default component.exports